var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import ComponentWithProvider from "@frameworks/shared-library/components/customHooks/ComponentWithProvider";
import TopPerformingFundsTabs from "@frameworks/shared-library/components/TopPerformingFunds/TopPerformingFundsTabs";
import { useSelector } from "react-redux";
import _ from "underscore";
import mutualFundDi from "@mainDi/features/mutualFund/servicelocator";
import GenericSelect from "@frameworks/shared-library/components/GenericSelect/GenericSelect";
import { generatePageHeaderName } from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
import ProductCategoryTabs, { EChangedComponent, } from "@frameworks/salesjourney/components/Generic/ProductCategoryTabs/ProductCategoryTabs";
import "@frameworks/salesjourney/stylesheets/components/Features/ProductBouquet/ProductBouquet.scss";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import somethingWentWrong from "@frameworks/shared-library/assets/images/markets/somethingWentWrong.svg";
import { EComponentFlow } from "@frameworks/shared-library/components/TopPerformingFunds/TopFundsTableDesk";
import PmsComponent from "@frameworks/pmsjourney/app/PMSApp";
import { useLocation } from "react-router-dom";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import useCalculateZoom from "@frameworks/web/utils/useCalculateZoom";
import OTC from "@frameworks/NCD/pages/ProductBouquet";
import { checkIfOtcIsAccessible } from "../../../utils/genericMethods";
var ProductBouquet = function (props) {
    var _a, _b, _c;
    var _d = __read(React.useState(), 2), mutualFundsSchemes = _d[0], setMutualFundsSchemes = _d[1];
    var _e = __read(React.useState(), 2), mfCategoryFilteredResult = _e[0], setMFCategoryFilteredResult = _e[1];
    var _f = __read(React.useState(null), 2), selectedCategoryData = _f[0], setSelectedCategoryData = _f[1];
    var zoom = useCalculateZoom();
    var _g = __read(React.useState(), 2), tabList = _g[0], setTabList = _g[1];
    var _h = __read(React.useState(false), 2), tabListError = _h[0], setTabListError = _h[1];
    var state = useLocation().state;
    var mutualFundsSchemeList = useSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.mutualFundsSchemeList;
    }, _.isEqual);
    var searchSortedDataData = useSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.updateData;
    }, _.isEqual);
    var searchParams = new URLSearchParams(location.search);
    var productTypeId = searchParams.get("producttypeid");
    var getCategoryListings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var otcIsAccessible, requestCategory, filteredRes, selectedProductType, selectedL1Category, selectedTabIndexL2, selectedL2CategoryDefault, selectedTabIndexL3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, checkIfOtcIsAccessible()];
                case 1:
                    otcIsAccessible = _b.sent();
                    requestCategory = [
                        ESubProductIds.Bonds,
                        ESubProductIds.UnlistedShares,
                        ESubProductIds.NCD,
                        ESubProductIds.StructuredProducts,
                    ];
                    return [4 /*yield*/, mutualFundDi.mutualFunds.getMFCategoryFilters({
                            removeCategoryCodes: !otcIsAccessible ? requestCategory : [],
                            skipFilters: [],
                        })];
                case 2:
                    filteredRes = _b.sent();
                    filteredRes = attachTabComponentToL3Data(filteredRes);
                    setMFCategoryFilteredResult(__assign({}, filteredRes));
                    selectedProductType = filteredRes.mfL1LevelData.filter(function (item) {
                        return (item === null || item === void 0 ? void 0 : item.productTypeId) === Number(productTypeId);
                    });
                    if (filteredRes) {
                        selectedL1Category = productTypeId
                            ? selectedProductType[0]
                            : filteredRes.mfL1LevelData[0];
                        selectedTabIndexL2 = filteredRes.mfL2LevelData[selectedL1Category === null || selectedL1Category === void 0 ? void 0 : selectedL1Category.value].findIndex(function (tab) { return tab.value == searchParams.get("productCode"); });
                        selectedL2CategoryDefault = filteredRes.mfL2LevelData[selectedL1Category.value][selectedTabIndexL2] || filteredRes.mfL2LevelData[selectedL1Category.value][0];
                        selectedTabIndexL3 = selectedL2CategoryDefault === null || selectedL2CategoryDefault === void 0 ? void 0 : selectedL2CategoryDefault.mfL3LevelData.findIndex(function (tab) { return tab.eventKey == searchParams.get("categoryCode"); });
                        setSelectedCategoryData({
                            selectedL1Category: selectedL1Category,
                            selectedL2Category: selectedL2CategoryDefault,
                            selectedL3Category: ((_a = selectedL2CategoryDefault.mfL3LevelData[selectedTabIndexL3]) === null || _a === void 0 ? void 0 : _a.eventKey) || selectedL2CategoryDefault.mfL3LevelData[0].eventKey,
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getTabsList = function (selectedCategory) {
        if (selectedCategory === void 0) { selectedCategory = selectedCategoryData.selectedL3Category; }
        mutualFundDi.mutualFunds
            .getSchemeCategory({ selectedCategory: selectedCategory, platformType: "RM_WEB" })
            .then(function (res) {
            if (res === null || res === void 0 ? void 0 : res.tabList) {
                setTabList(__spreadArray([], __read(res.tabList), false));
            }
            else {
                setTabList([]);
            }
            setTabListError(false);
        })
            .catch(function () { return setTabListError(true); });
    };
    var attachTabComponentToL3Data = function (data) {
        var localCopiedData = JSON.parse(JSON.stringify(data));
        Object.keys(localCopiedData.mfL2LevelData).forEach(function (item) {
            localCopiedData.mfL2LevelData[item] = localCopiedData.mfL2LevelData[item].map(function (obj) {
                return __assign(__assign({}, obj), { mfL3LevelData: obj.mfL3LevelData.map(function (l3Data) {
                        return __assign(__assign({}, l3Data), { tabContent: generateSubCategoryTabContent(l3Data.eventKey) });
                    }) });
            });
        });
        return localCopiedData;
    };
    var mfCategorySelectionCallback = function (data, changedComponent, isL1Category) {
        var _a, _b, _c;
        if (isL1Category === void 0) { isL1Category = false; }
        var localSelectedCategory = __assign({}, selectedCategoryData);
        switch (changedComponent) {
            case EChangedComponent.SELECT:
                var localData = data;
                if (isL1Category) {
                    localSelectedCategory.selectedL1Category = localData;
                    var l2CatData = !!mfCategoryFilteredResult.mfL2LevelData &&
                        mfCategoryFilteredResult.mfL2LevelData[localData.value];
                    localSelectedCategory.selectedL2Category =
                        l2CatData && l2CatData.length ? l2CatData[0] : undefined;
                    localSelectedCategory.selectedL3Category =
                        localSelectedCategory.selectedL2Category.mfL3LevelData[0].eventKey;
                }
                else {
                    localSelectedCategory.selectedL2Category = localData;
                    var l3SelectedKey = !!((_a = localSelectedCategory === null || localSelectedCategory === void 0 ? void 0 : localSelectedCategory.selectedL2Category) === null || _a === void 0 ? void 0 : _a.mfL3LevelData) &&
                        ((_b = localSelectedCategory === null || localSelectedCategory === void 0 ? void 0 : localSelectedCategory.selectedL2Category) === null || _b === void 0 ? void 0 : _b.mfL3LevelData.length) &&
                        localSelectedCategory.selectedL2Category.mfL3LevelData[0];
                    localSelectedCategory.selectedL3Category =
                        (_c = l3SelectedKey === null || l3SelectedKey === void 0 ? void 0 : l3SelectedKey.eventKey) !== null && _c !== void 0 ? _c : "";
                    getTabsList(localSelectedCategory.selectedL3Category);
                }
                break;
            case EChangedComponent.TAB:
                localSelectedCategory.selectedL3Category = data;
                break;
        }
        setSelectedCategoryData(localSelectedCategory);
    };
    //Error State for these three categories
    var ErrorState = function (_a) {
        var onRetry = _a.onRetry;
        return (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: somethingWentWrong, msg: "Something went wrong", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing page, or try again later"),
                    React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: onRetry }, "Try Again")) })));
    };
    //Common Tab with Error handling
    var TabContentWithErrorHandling = function (_a) {
        var tabListError = _a.tabListError, tabList = _a.tabList, getTabsList = _a.getTabsList, renderContent = _a.renderContent, renderError = _a.renderError;
        if (tabListError) {
            return React.createElement(ErrorState, { onRetry: getTabsList });
        }
        if (tabList && tabList.length > 0) {
            return renderContent;
        }
        return renderError ? renderError() : generateNotFoundErrorScreen();
    };
    // This function is used to return the required component for a specific tab based on id
    var generateSubCategoryTabContent = function (subCategoryId, productCode) {
        switch (subCategoryId) {
            case ESubProductIds.MutualFund:
                return (React.createElement(ComponentWithProvider, { component: React.createElement(TabContentWithErrorHandling, { tabListError: tabListError, tabList: tabList, getTabsList: getTabsList, renderContent: React.createElement(TopPerformingFundsTabs, { viewAll: true, showTabs: true, mutualFundsSchemeList: mutualFundsSchemes, tabList: tabList, categoryCode: subCategoryId.toString(), productCode: productCode, componentFlow: EComponentFlow.PRODUCT_BOUQUET }) }) }));
            case ESubProductIds.PMS:
                return (React.createElement(ComponentWithProvider, { component: React.createElement(TabContentWithErrorHandling, { tabListError: tabListError, tabList: tabList, getTabsList: getTabsList, renderContent: React.createElement(PmsComponent, { subCategoryId: subCategoryId.toString() }), renderError: generateNotFoundErrorScreen }) }));
            case ESubProductIds.AIF:
                return (React.createElement(ComponentWithProvider, { component: React.createElement(TabContentWithErrorHandling, { tabListError: tabListError, tabList: tabList, getTabsList: getTabsList, renderContent: React.createElement(PmsComponent, { subCategoryId: subCategoryId.toString() }), renderError: generateNotFoundErrorScreen }) }));
            case ESubProductIds.NCD:
                return (React.createElement(ComponentWithProvider, { component: React.createElement(TabContentWithErrorHandling, { tabListError: tabListError, tabList: tabList, getTabsList: getTabsList, renderContent: React.createElement(OTC, { subCategoryId: subCategoryId.toString(), productCode: productCode }), renderError: generateNotFoundErrorScreen }) }));
            case ESubProductIds.Bonds:
                return (React.createElement(ComponentWithProvider, { component: React.createElement(TabContentWithErrorHandling, { tabListError: tabListError, tabList: tabList, getTabsList: getTabsList, renderContent: React.createElement(OTC, { subCategoryId: subCategoryId.toString(), productCode: productCode }), renderError: generateNotFoundErrorScreen }) }));
            case ESubProductIds.UnlistedShares:
                return (React.createElement(ComponentWithProvider, { component: React.createElement(TabContentWithErrorHandling, { tabListError: tabListError, tabList: tabList, getTabsList: getTabsList, renderContent: React.createElement(OTC, { subCategoryId: subCategoryId.toString(), productCode: productCode }), renderError: generateNotFoundErrorScreen }) }));
            case ESubProductIds.StructuredProducts:
                return (React.createElement(ComponentWithProvider, { component: React.createElement(TabContentWithErrorHandling, { tabListError: tabListError, tabList: tabList, getTabsList: getTabsList, renderContent: React.createElement(OTC, { subCategoryId: subCategoryId.toString(), productCode: productCode }), renderError: generateNotFoundErrorScreen }) }));
            default:
                return generateNotFoundErrorScreen();
        }
    };
    var generateNotFoundErrorScreen = function () {
        return (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: noResultsFound, msg: "  ", customComp: React.createElement("div", { className: "flexCenter" },
                    React.createElement("p", { className: "DMSanN_18_400" }, "Coming soon!")) })));
    };
    var generateSomethingWentErrorScreen = function () {
        return (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: somethingWentWrong, msg: "Something went wrong", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing page, or try again later"),
                    React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () { return getTabsList(); }, hidden: !tabListError }, "Try Again")) })));
    };
    React.useEffect(function () {
        if (selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL3Category) {
            getTabsList();
            localStorage.setItem("CategoryCode", selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL3Category);
        }
    }, [selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL3Category]);
    React.useEffect(function () {
        if (searchSortedDataData && searchSortedDataData.length > 0) {
            setMutualFundsSchemes(searchSortedDataData);
        }
        else {
            setMutualFundsSchemes(mutualFundsSchemeList);
        }
    }, [searchSortedDataData]);
    React.useEffect(function () {
        !!props.setHeaderLeftComponent &&
            props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex align-items-center gap-4" },
                generatePageHeaderName("Browse offerings"),
                React.createElement(GenericSelect, { options: mfCategoryFilteredResult === null || mfCategoryFilteredResult === void 0 ? void 0 : mfCategoryFilteredResult.mfL1LevelData, value: selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL1Category, className: "round-select DMSansMedium_15_500 txt-grey-shade1", classNamePrefix: "mf-select-dropdown", isSearchable: false, showSelectOptionByDefault: false, onChange: function (data) {
                        mfCategorySelectionCallback(data, EChangedComponent.SELECT, true);
                    } })));
    }, [mfCategoryFilteredResult, selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL1Category]);
    React.useEffect(function () {
        if (!!tabList && tabList.length) {
            setSelectedCategoryData(function (prevState) {
                var localState = __assign({}, prevState);
                localState.selectedL2Category = __assign(__assign({}, localState.selectedL2Category), { mfL3LevelData: localState.selectedL2Category.mfL3LevelData.map(function (item) {
                        return __assign(__assign({}, item), { tabContent: generateSubCategoryTabContent(item.eventKey, localState.selectedL2Category.value) });
                    }) });
                return localState;
            });
        }
    }, [tabList, selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL3Category]);
    React.useEffect(function () {
        getCategoryListings();
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (state === null || state === void 0 ? void 0 : state.select) {
            setSelectedCategoryData(__assign(__assign({}, selectedCategoryData), { selectedL1Category: {
                    label: (_a = state === null || state === void 0 ? void 0 : state.productName) === null || _a === void 0 ? void 0 : _a.label,
                    value: (_b = state === null || state === void 0 ? void 0 : state.productName) === null || _b === void 0 ? void 0 : _b.value,
                }, selectedL2Category: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.select), { mfL3LevelData: (_d = (_c = state === null || state === void 0 ? void 0 : state.select) === null || _c === void 0 ? void 0 : _c.mfL3LevelData) === null || _d === void 0 ? void 0 : _d.map(function (item) {
                        var _a;
                        return __assign(__assign({}, item), { tabContent: generateSubCategoryTabContent(String(item.eventKey), String((_a = state === null || state === void 0 ? void 0 : state.select) === null || _a === void 0 ? void 0 : _a.value)) });
                    }) }), selectedL3Category: String(state === null || state === void 0 ? void 0 : state.tabId) }));
            getTabsList(state === null || state === void 0 ? void 0 : state.tabId);
        }
    }, [mfCategoryFilteredResult, state === null || state === void 0 ? void 0 : state.select]);
    return (React.createElement(GridContainer, { parentClass: "primary-product-bouquet-container mw-100 p-0", style: { zoom: zoom } },
        React.createElement(ProductCategoryTabs, { selectAndTabChangeCallback: function (data, changedComponent) {
                mfCategorySelectionCallback(data, changedComponent);
            }, dropDownList: (mfCategoryFilteredResult === null || mfCategoryFilteredResult === void 0 ? void 0 : mfCategoryFilteredResult.mfL2LevelData) && selectedCategoryData
                ? mfCategoryFilteredResult === null || mfCategoryFilteredResult === void 0 ? void 0 : mfCategoryFilteredResult.mfL2LevelData[selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL1Category.value]
                : [], tabsDataList: (_b = (_a = selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL2Category) === null || _a === void 0 ? void 0 : _a.mfL3LevelData) !== null && _b !== void 0 ? _b : [], selectedDropdownObject: selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL2Category, selectedTabEventKey: (_c = selectedCategoryData === null || selectedCategoryData === void 0 ? void 0 : selectedCategoryData.selectedL3Category) !== null && _c !== void 0 ? _c : "" })));
};
export default ProductBouquet;
